import countries from "../../../config/market-countries.json";

/** Shared English country labels and ordering: SSR must not depend on runtime ICU data. */
const COUNTRY_NAMES = new Map(countries.map(country => [country.code, country.name]));
const COUNTRY_ORDER = new Map(countries.map((country, index) => [country.code, index]));

/** ISO 3166-1 country choices, independent of delivery eligibility. */
export const MARKET_COUNTRY_CODES = countries.map(country => country.code);

export function countryName(code: string): string {
  return COUNTRY_NAMES.get(code) ?? code;
}

/** Stable registry order, with unknown persisted codes placed last in code order. */
export function compareCountryCodes(a: string, b: string): number {
  return (COUNTRY_ORDER.get(a) ?? countries.length) - (COUNTRY_ORDER.get(b) ?? countries.length) ||
    (a < b ? -1 : a > b ? 1 : 0);
}
